import { useDispatch, useSelector } from "react-redux";
import Workouts from "../../pages/Exercices/workout/Workouts";
import { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, Link, useNavigate, useParams } from "react-router-dom";
import {fetchExerciseCategories}  from "../../../core/store/sport/categories_sport/thunk";


const CategoryDetails = () => {
  const { categoryId } = useParams();
  const dispatch = useDispatch();
  const { categories, status } = useSelector((state) => state.exerciseCategories);

  // Charger les catégories si elles ne sont pas encore disponibles
  useEffect(() => {
    if (categories.length === 0) {
      dispatch(fetchExerciseCategories());
    }
  }, [dispatch, categories]);

  const categoryDetails = categories.find((cat) => cat.id === Number(categoryId));

  if (status === "loading") return <p>Chargement...</p>;
  if (!categoryDetails) return <p>Catégorie non trouvée.</p>;

  return (
    <div>
      <h2>{categoryDetails.name}</h2>
      <p>{categoryDetails.description}</p>
      <ul>
        {categoryDetails.exercises?.map((exercise) => (
          <li key={exercise.id}>{exercise.name}</li>
        ))}
      </ul>
    </div>
  );
};

// Application principale avec le routage
  
  export default CategoryDetails ;
  